import { graphql } from '@/generated/gql';

export const NEGOTIATION_REMINDER_SETTINGS_QUERY = graphql(/* GraphQL */ `
  query ReminderSettingsQuery(
    $targetId: UUID!
    $type: TsrctReminderType!
    $variant: TsrctReminderConfigVariant!
    $isNegotiationCase: Boolean! = false
    $isSourcingCase: Boolean! = false
  ) {
    tesseract {
      reminderConfig(targetId: $targetId, type: $type, variant: $variant) {
        reminderConfigId
        targetId
        type
        variant
        source
        reminderDelayWorkingDays
        cancellationDelayWorkingDays
        executionTime
        timezone
      }
      negotiationCase(id: $targetId) @include(if: $isNegotiationCase) {
        id
        status
      }
      sourcingCase(id: $targetId) @include(if: $isSourcingCase) {
        id
        status
      }
    }
  }
`);
